import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Header } from '../components/Header'
import { useAlert } from '../contexts/AlertContext'
import { useAuth } from '../hooks/useAuth'
import { vehicleFleetGetAccess } from '../lib/apiPhpAdapter'
import { VehicleFleetAppointPanel } from './vehicle-fleet/VehicleFleetAppointPanel'
import { VehicleFleetCalendarPanel } from './vehicle-fleet/VehicleFleetCalendarPanel'
import { VehicleFleetVehiclesPanel } from './vehicle-fleet/VehicleFleetVehiclesPanel'

export default function VehicleFleetManagerView() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const { showAlert } = useAlert()
  const [ready, setReady] = useState(false)
  const [canApprove, setCanApprove] = useState(false)
  const [tab, setTab] = useState<'vehicles' | 'drivers' | 'calendar'>('vehicles')

  useEffect(() => {
    let cancelled = false
    vehicleFleetGetAccess()
      .then((a) => {
        if (cancelled) return
        if (!a.canFleetAdmin) {
          navigate('/vehicle-fleet', { replace: true })
          return
        }
        setCanApprove(!!(a.canApproveReservations || a.isDirector || a.isItAdmin))
        setReady(true)
      })
      .catch(() => {
        if (!cancelled) navigate('/vehicle-fleet', { replace: true })
      })
    return () => {
      cancelled = true
    }
  }, [navigate])

  if (!ready) {
    return (
      <div className="app">
        <Header title="Rezervace vozidel — Autopark" />
        <div style={{ padding: '2rem' }}>Načítání…</div>
      </div>
    )
  }

  return (
    <div className="app">
      <Header
        leftButtons={
          <button type="button" className="back-button" onClick={() => navigate('/vehicle-fleet')}>
            ← Zpět na výběr role
          </button>
        }
        title="Rezervace vozidel — Administrátor autoparku"
        rightContent={
          <span style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '0.9rem' }}>{user?.name}</span>
        }
      />
      <div style={{ padding: '1.25rem 1.5rem', maxWidth: 960, margin: '0 auto' }}>
        <div style={{ display: 'flex', gap: 8, marginBottom: 14, flexWrap: 'wrap' }}>
          <button
            type="button"
            className={tab === 'vehicles' ? 'system-button' : undefined}
            onClick={() => setTab('vehicles')}
          >
            Vozidla
          </button>
          <button
            type="button"
            className={tab === 'drivers' ? 'system-button' : undefined}
            onClick={() => setTab('drivers')}
          >
            Řidiči
          </button>
          <button
            type="button"
            className={tab === 'calendar' ? 'system-button' : undefined}
            onClick={() => setTab('calendar')}
          >
            Kalendář
          </button>
        </div>
        {tab === 'vehicles' ? <VehicleFleetVehiclesPanel showAlert={showAlert} /> : null}
        {tab === 'drivers' ? (
          <div style={{ display: 'grid', gap: 16 }}>
            <VehicleFleetAppointPanel
              kind="drivers"
              title="Řidiči"
              description="Jmenujte uživatele s přístupem do role Řidič — mohou rezervovat vozidla. Jako administrátor autoparku můžete také sami otevřít roli Řidič."
              showAlert={showAlert}
            />
            <VehicleFleetCalendarPanel showAlert={showAlert} canManage canApprove={canApprove} />
          </div>
        ) : null}
        {tab === 'calendar' ? (
          <VehicleFleetCalendarPanel showAlert={showAlert} canManage canApprove={canApprove} />
        ) : null}
      </div>
    </div>
  )
}
